import {
  InputProps,
  PostcodeProps,
  ValidatedFieldProps,
  Widget,
} from '@kanda-libs/ks-component-ts';

import { EmploymentStatusType } from 'pages/Apply/YourInfo/EmploymentInformationFields/PrimaryEmployment/types';

export interface AddressManualWidgets {
  BuildingName: (props: ValidatedFieldProps<InputProps>) => JSX.Element;
  BuildingNumber: (props: ValidatedFieldProps<InputProps>) => JSX.Element;
  Line1: (props: ValidatedFieldProps<InputProps>) => JSX.Element;
  Line2: (props: ValidatedFieldProps<InputProps>) => JSX.Element;
  City: (props: ValidatedFieldProps<InputProps>) => JSX.Element;
  County: (props: ValidatedFieldProps<InputProps>) => JSX.Element;
  Country: (props: ValidatedFieldProps<InputProps>) => JSX.Element;
  Postcode: (props: ValidatedFieldProps<PostcodeProps>) => JSX.Element;
}

// (props: WidgetArrayInputProps<ValidatedFieldProps<PostcodeProps>>) => JSX.Element

export const PRIMARY_EMPLOYED_WIDGETS: Record<
  EmploymentStatusType,
  AddressManualWidgets
> = {
  employed: {
    BuildingName:
      Widget.CreditEmploymentDetailsEmployedDetailsEmployerAddressBuildingName,
    BuildingNumber:
      Widget.CreditEmploymentDetailsEmployedDetailsEmployerAddressBuildingNumber,
    Line1: Widget.CreditEmploymentDetailsEmployedDetailsEmployerAddressLine1,
    Line2: Widget.CreditEmploymentDetailsEmployedDetailsEmployerAddressLine2,
    City: Widget.CreditEmploymentDetailsEmployedDetailsEmployerAddressCity,
    County: Widget.CreditEmploymentDetailsEmployedDetailsEmployerAddressCounty,
    Country:
      Widget.CreditEmploymentDetailsEmployedDetailsEmployerAddressCountry,
    Postcode:
      Widget.CreditEmploymentDetailsEmployedDetailsEmployerAddressPostcode,
  },
  self_employed: {
    BuildingName:
      Widget.CreditEmploymentDetailsSelfEmployedDetailsBusinessAddressBuildingName,
    BuildingNumber:
      Widget.CreditEmploymentDetailsSelfEmployedDetailsBusinessAddressBuildingNumber,
    Line1:
      Widget.CreditEmploymentDetailsSelfEmployedDetailsBusinessAddressLine1,
    Line2:
      Widget.CreditEmploymentDetailsSelfEmployedDetailsBusinessAddressLine2,
    City: Widget.CreditEmploymentDetailsSelfEmployedDetailsBusinessAddressCity,
    County:
      Widget.CreditEmploymentDetailsSelfEmployedDetailsBusinessAddressCounty,
    Country:
      Widget.CreditEmploymentDetailsSelfEmployedDetailsBusinessAddressCountry,
    Postcode:
      Widget.CreditEmploymentDetailsSelfEmployedDetailsBusinessAddressPostcode,
  },
};

export const SECONDARY_EMPLOYED_WIDGETS: Record<
  EmploymentStatusType,
  AddressManualWidgets
> = {
  employed: {
    BuildingName:
      Widget.CreditAdditionalEmploymentDetailsEmployedDetailsEmployerAddressBuildingNameArrayInput,
    BuildingNumber:
      Widget.CreditAdditionalEmploymentDetailsEmployedDetailsEmployerAddressBuildingNumberArrayInput,
    Line1:
      Widget.CreditAdditionalEmploymentDetailsEmployedDetailsEmployerAddressLine1ArrayInput,
    Line2:
      Widget.CreditAdditionalEmploymentDetailsEmployedDetailsEmployerAddressLine2ArrayInput,
    City: Widget.CreditAdditionalEmploymentDetailsEmployedDetailsEmployerAddressCityArrayInput,
    County:
      Widget.CreditAdditionalEmploymentDetailsEmployedDetailsEmployerAddressCountyArrayInput,
    Country:
      Widget.CreditAdditionalEmploymentDetailsEmployedDetailsEmployerAddressCountryArrayInput,
    Postcode:
      Widget.CreditAdditionalEmploymentDetailsEmployedDetailsEmployerAddressPostcodeArrayInput,
  },
  self_employed: {
    BuildingName:
      Widget.CreditAdditionalEmploymentDetailsSelfEmployedDetailsBusinessAddressBuildingNameArrayInput,
    BuildingNumber:
      Widget.CreditAdditionalEmploymentDetailsSelfEmployedDetailsBusinessAddressBuildingNumberArrayInput,
    Line1:
      Widget.CreditAdditionalEmploymentDetailsSelfEmployedDetailsBusinessAddressLine1ArrayInput,
    Line2:
      Widget.CreditAdditionalEmploymentDetailsSelfEmployedDetailsBusinessAddressLine2ArrayInput,
    City: Widget.CreditAdditionalEmploymentDetailsSelfEmployedDetailsBusinessAddressCityArrayInput,
    County:
      Widget.CreditAdditionalEmploymentDetailsSelfEmployedDetailsBusinessAddressCountyArrayInput,
    Country:
      Widget.CreditAdditionalEmploymentDetailsSelfEmployedDetailsBusinessAddressCountryArrayInput,
    Postcode:
      Widget.CreditAdditionalEmploymentDetailsSelfEmployedDetailsBusinessAddressPostcodeArrayInput,
  },
};
